angular.module("indicators_types")

    .controller("IndicatorsTypesEditCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', 'modalService', '$filter', function (LoginService, $rootScope, $scope, $http, $stateParams, Restangular, $state, modalService, $filter) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("INDICATORS_TYPES_WRITE");

        $rootScope.title = $filter('translate')('indicators_types.title');
        if (angular.isUndefined($stateParams.id) || $stateParams.id == ""   ) {
            
            $rootScope.breadcrumb = [
            { title: $filter('translate')('indicators_types.list'), url: "indicators_types.list" },
            { title: $filter('translate')('indicators_types.add') }
            ];
            $scope.indicator_type = {
                name: ''
            };
        }
        else {
            $rootScope.breadcrumb = [
            { title: $filter('translate')('indicators_types.list'), url: "indicators_types.list" },
            { title: $filter('translate')('indicators_types.edit') }
            ];
            Restangular.one('IndicatorsTypes', $stateParams.id).get().then(function (results) {
                $scope.indicator_type = results;
            }, function (response) {
                $scope.errorMessage = response.message;
            });
        }


        $scope.saveIndicatorType = function () {
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "")
                Restangular.all('IndicatorsTypes').post($scope.indicator_type).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('indicators_types.create_success'));
                        $state.go("indicators_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            else {
                $scope.indicator_type.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('indicators_types.modify_success'));
                        $state.go("indicators_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        };

        $scope.deleteIndicatorType = function () {

            modalService.confirm({
                title: $filter('translate')('indicators_types.delete'),
                message: $filter('translate')('indicators_types.delete_message') + " " + $scope.indicator_type.name + "?",
                onAccept: function () {
                    Restangular.one('IndicatorsTypes', $stateParams.id).remove().then(function () {
                        toastr.success($filter('translate')('indicators_types.delete_success'));
                        $state.go("indicators_types.list");
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

    }])

;